export const isAppConnected = (status) => {
    if (status === true)
        return true;
    const CONNECTED_STATUSES = ['CONNECTED', 'NOT_CONFIGURED', 'SYNCING'];
    return CONNECTED_STATUSES.includes(status);
};
